import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { getSkillStoreData } from "../../../../redux/actions/skill";
import { Pagination } from "antd";
import Loader from "../../../../components/loader";
import EmptyLoader from "../../../../components/emptyLoader";
import SkillItem from "./SkillItem";
import { ArrowLeft } from "lucide-react";

const SkillCollection = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const params = useParams();
  let _url = params.id;

  const agentHubData = useSelector((state) => state.skillReducer?.aiAgentHubData);
  const [isLoading, setIsLoading] = useState(true);
  const [totalCount, setTotalCount] = useState(0);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(9);
  const [paginatedData, setPaginatedData] = useState([]);
  const [filteredData, setFilteredData] = useState(null);

  useEffect(() => {
    getSkillData();
  }, [_url]);

  useEffect(() => {
    if (filteredData) {
      getPaginatedData();
    }
  }, [page, filteredData]);

  const getSkillData = async () => {
    setIsLoading(true);
    const response = await dispatch(getSkillStoreData());
    
    if (_url !== "All") {
      // Filter by category
      const filtered = response?.results?.filter(item => item?.category === _url);
      setFilteredData(filtered?.length > 0 ? filtered[0]?.skills : null);
      const skillsCount = filtered?.length > 0 ? filtered[0]?.skillCount : 0;
      setTotalCount(skillsCount);
    } else {
      const allSkills = [];
      response?.results?.forEach(category => {
        if (category?.skills && Array.isArray(category?.skills)) {
          allSkills.push(...category?.skills);
        }
      });
      setFilteredData(allSkills);
      const skillsCount = allSkills?.length>0?allSkills?.length:0
      setTotalCount(skillsCount);
    }
    
    setIsLoading(false);
  };

  const getPaginatedData = () => {
    if (!filteredData || filteredData.length === 0) return;
    const offset = (page - 1) * pageSize;
    const paginatedSkills = filteredData.slice(offset, offset + pageSize);
    
    setPaginatedData(paginatedSkills);
  };

  const displayCategorySkills = () => {
   

    return (
      <>
      {isLoading?<Loader/>:
       totalCount===0?<EmptyLoader  message="No Agents Found in this category"
       />:
        <>
        <div className="tp-title flex-title">
          <div className="skill-inner-title">
              <ArrowLeft className="back-arrow" onClick={()=>history.goBack()}/>
            <h3>{_url}</h3>
          </div>          
          <div className="rt-btns"></div>
        </div>
        
        <div className="tp-boxes">
          <div className="row">
            {paginatedData?.map((skill) => (
              <div className="col-md-4" key={skill.id}>
                <SkillItem item={skill} key={skill.id} opt={false} />
              </div>
            ))}
          </div>
        </div>
        
        <Pagination
          current={page}
          pageSize={pageSize}
          total={totalCount}
          onChange={handlePageChange}
          hideOnSinglePage={false}
          showSizeChanger={false}
        />
        </>
      }
      </>
    );
  };

  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
  };

  return (
    <div className="template-flex">
      <div className="template-box scrollable">
        {displayCategorySkills()}
      </div>
    </div>
  );
};

export default SkillCollection;
